import { AHIconType } from "arkh";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";
import { TeamHeaderButton } from "../../../Team/TeamHomeNavigator/TeamHome/TeamHeader/TeamHeaderButton";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function StorecastHeaderButton(props: {
  onPress(): void;
  title?: string;
  icon?: AHIconType;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return (
    <TeamHeaderButton
      spaceLeft={isCompact ? "small" : "medium"}
      spaceRight={isCompact ? "small" : "medium"}
      icon={props.icon}
      tintColor="text-primary"
      onPress={props.onPress}
      onPressIn={onPressInHaptic}
      title={props.title}
    />
  );
}
